import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import FieldSettings from "./FieldSettings";
import Fields from "./Fields";
import { useSelector } from "react-redux";

function InnerTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      width="100%"
      minWidth={0}
      maxWidth="100%"
      {...other}
    >
      {value === index && <Box p={{ xs: 1, sm: 2 }} minWidth={0} boxSizing="border-box">{children}</Box>}
    </Box>
  );
}

InnerTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function innerA11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    minWidth: 0,
    maxWidth: "100%",
    overflowWrap: "anywhere",
    backgroundColor: theme.palette.background.paper,
  },
  tabs: {
    minHeight: "40px",
    display: "flex",
    minWidth: 0,
    maxWidth: "100%",
  },
  tab: {
    maxWidth: "100%",
    minWidth: "unset",
    minHeight: "40px",
    fontSize: "0.75rem",
    flex: 1,
  },
  fieldButton: {
    width: "100%",
    marginBottom: "16px",
  },
}));

const FieldsSelector = () => {
  const classes = useStyles();
  const [innerValue, setInnerValue] = React.useState(0);

  const { editingField } = useSelector(({ formBuilder }) => formBuilder);

  useEffect(() => {
    if (editingField) {
      setInnerValue(1);
    } else {
      setInnerValue(0);
    }
  }, [editingField]);

  const handleInnerChange = (event, newValue) => {
    setInnerValue(newValue);
  };

  return (
    <Box className={classes.root}>
      <Tabs
        value={innerValue}
        onChange={handleInnerChange}
        aria-label="inner tabs example"
        indicatorColor="primary"
        textColor="primary"
        variant="scrollable"
        scrollButtons="auto"
        className={classes.tabs}
      >
        <Tab
          label="افزودن فیلد"
          {...innerA11yProps(0)}
          className={classes.tab}
        />
        <Tab
          label="تنظیمات فیلد"
          {...innerA11yProps(1)}
          className={classes.tab}
        />
      </Tabs>
      <InnerTabPanel value={innerValue} index={0}>
        <Fields />
      </InnerTabPanel>

      <InnerTabPanel value={innerValue} index={1}>
        <FieldSettings />
      </InnerTabPanel>
    </Box>
  );
};

export default FieldsSelector;
